import { useSyncExternalStore } from 'react';
import { leer, suscribir, type Centralita } from '@/lib/centralita';

/**
 * El estado de la centralita, para cualquier componente que lo necesite.
 *
 * useSyncExternalStore en vez de un contexto porque el estado no vive en React:
 * lo mueven los eventos que llegan del iframe de Amazon Connect, que pueden
 * caer en cualquier momento, incluso mientras React renderiza. Este hook es la
 * forma que da React de leer una fuente externa sin arriesgarse a enseñar dos
 * valores distintos en el mismo render.
 */
export function useCentralita(): Centralita {
  return useSyncExternalStore(suscribir, leer, leer);
}

export { llamar, colgar, aceptar, cerrarTrabajo, cambiarEstadoAgente, normalizar, reintentarSesion, URL_ACCESO } from '@/lib/centralita';
